import {CreateFaceInfo,UpdateFaceInfo,LoadInfo,EnterList,GetToken} from '@/assets/js/api/rllr'
const rllr = {
  state: {
  },
  actions: {
    loadInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        LoadInfo().then(res => {
          resolve(res.data)
        })
      })
    },
    createFaceInfo ({ commit },params) {
      return new Promise((resolve, reject) => {
        CreateFaceInfo(params).then(res => {
          resolve(res.data)
        })
      })
    },
    updateFaceInfo ({ commit },params) {
      return new Promise((resolve, reject) => {
        UpdateFaceInfo(params).then(res => {
          resolve(res.data)
        })
      })
    },
    enterList ({ commit },params) {
      return new Promise((resolve, reject) => {
        EnterList(params).then(res => {
          resolve(res.data)
        })
      })
    },
    getToken ({ commit }) {
      return new Promise((resolve, reject) => {
        GetToken().then(res => {
          resolve(res.data)
        })
      })
    }
  },
  mutations: {
  },
  namespaced: true
}

export default rllr



// WEBPACK FOOTER //
// ./src/store/modules/rllr.js